import ff from './ff';

export default class i1yd { // 抽選情報

static d_defs = {

/*
  DROP TABLE t_i1yr;
  CREATE TABLE t_i1yr (_key SERIAL PRIMARY KEY, _vsn INTEGER, _ltt INTEGER, _fst INTEGER, 
    i1yrb21f INTEGER,
    i1yri11d TEXT,
    i1yri11i INTEGER,
    i1yri21d TEXT,
    i1yrs11i INTEGER,
    i1yrcx1i INTEGER,
    i1yrcy1t TEXT,
    i1yrcy1f INTEGER,
    i1yrcz1i INTEGER
    , CONSTRAINT i1yr_unq1 UNIQUE (i1yrb21f, i1yri11d)
  );
  INSERT INTO t_i1yr (_vsn, _ltt, i1yrb21f, i1yri11d, i1yri11i, i1yrs11i, i1yrcx1i, i1yrcy1t, i1yrcy1f, i1yrcz1i)
  VALUES (1, 1, 1, '2021-11-01', 10, 0, 9999, '2000-01-01 00:00:00', 1, 10);
  UPDATE t_i1yr SET _fst = _key;
*/

  i1yr: {
    0: {
      pfx: '抽選情報',
      b_vsn: false, // 歴管理なし
      dd_fldDefss: {

        i1yrb21f: { // c20m_fst
          pfx: '利用会社',
          type: 'Inp',
        },

        i1yri11d: {
          pfx: '利用日',
          type: 'PckDate',
        },

        i1yri11i: {
          pfx: 'エントリー数',
          type: 'Inp',
          lo_qrys: [
            _d_vals => {
              let _qry =     `
                INSERT INTO
                  t_i1yr
                (
                  i1yrb21f,
                  i1yri11d,
                  i1yri11i,
                  i1yrs11i,
                  i1yrs12i,
                  i1yrcz1i
                ) VALUES (
                  ${global.t?.state.sgcd_cmnStgs.c20r_fst},
                  "${_d_vals.i1yri11d}",
                  (
                    SELECT
                      COUNT(*)
                    FROM
                      t_i1zr AS A
                    WHERE
                      COALESCE(A.i1zrcz1i, 10) <> 0
                      AND A.i1zrb21f = ${global.t?.state.sgcd_cmnStgs.c20r_fst}
                      AND A._vsn = A._ltt
                      AND A.i1zri21d = "${_d_vals.i1yri11d}"
                      AND A.i1zrs21i IN (40, 60, 80)
                  ),
                  0,
                  0,
                  10
                )
                ON CONFLICT ON CONSTRAINT i1yr_unq1
                DO UPDATE SET
                  i1yri11i = (
                    SELECT
                      COUNT(*)
                    FROM
                      t_i1zr AS A
                    WHERE
                      COALESCE(A.i1zrcz1i, 10) <> 0
                      AND A.i1zrb21f = ${global.t?.state.sgcd_cmnStgs.c20r_fst}
                      AND A._vsn = A._ltt
                      AND A.i1zri21d = "${_d_vals.i1yri11d}"
                      AND A.i1zrs21i IN (40, 60, 80)
                  )
                WHERE
                  COALESCE(t_i1yr.i1yrcz1i, 10) <> 0
                  AND t_i1yr.i1yrb21f = ${global.t?.state.sgcd_cmnStgs.c20r_fst}
                  AND t_i1yr.i1yri11d = "${_d_vals.i1yri11d}"
                  AND COALESCE(t_i1yr.i1yrs11i,0) = 0
              `;

              return _qry;
            },
          ],
        },

        i1yri12i: {
          pfx: '優先エントリー数',
          type: 'Inp',
          lo_qrys: [
            _d_vals => {
              let _qry =     `
                INSERT INTO
                  t_i1yr
                (
                  i1yrb21f,
                  i1yri11d,
                  i1yri12i,
                  i1yrs11i,
                  i1yrs12i,
                  i1yrcz1i
                ) VALUES (
                  ${global.t?.state.sgcd_cmnStgs.c20r_fst},
                  "${_d_vals.i1yri11d}",
                  (
                    SELECT
                      COUNT(*)
                    FROM
                      t_i1zr AS A
                    WHERE
                      COALESCE(A.i1zrcz1i, 10) <> 0
                      AND A.i1zrb21f = ${global.t?.state.sgcd_cmnStgs.c20r_fst}
                      AND A._vsn = A._ltt
                      AND A.i1zri21d = "${_d_vals.i1yri11d}"
                      AND A.i1zrs22i IN (40, 60, 80)
                  ),
                  0,
                  0,
                  10
                )
                ON CONFLICT ON CONSTRAINT i1yr_unq1
                DO UPDATE SET
                  i1yri12i = (
                    SELECT
                      COUNT(*)
                    FROM
                      t_i1zr AS A
                    WHERE
                      COALESCE(A.i1zrcz1i, 10) <> 0
                      AND A.i1zrb21f = ${global.t?.state.sgcd_cmnStgs.c20r_fst}
                      AND A._vsn = A._ltt
                      AND A.i1zri21d = "${_d_vals.i1yri11d}"
                      AND A.i1zrs22i IN (40, 60, 80)
                  )
                WHERE
                  COALESCE(t_i1yr.i1yrcz1i, 10) <> 0
                  AND t_i1yr.i1yrb21f = ${global.t?.state.sgcd_cmnStgs.c20r_fst}
                  AND t_i1yr.i1yri11d = "${_d_vals.i1yri11d}"
                  AND COALESCE(t_i1yr.i1yrs12i,0) = 0
              `;
              ff.l('i1yd 152: {}'.f(_qry))
              return _qry;
            },
          ],
        },

        i1yri21d: { // エントリー
          pfx: '抽選日',
          type: 'PckDate',
        },

        i1yri22d: { // 優先エントリー
          pfx: '抽選日',
          type: 'PckDate',
        },


        i1yrs11i: { // エントリー
          pfx: '抽選状況',
          type: 'Pck',
          n_col: 8,
          ld_iss: [
            { key: -1, pfx: ' ' },
            { key:  0, pfx: '抽選前' },
            { key: 20, pfx: '抽選済み' },
          ],
          lo_qrys: [
            _d_vals => {
              let _qry = `
                UPDATE
                  t_i1yr
                SET
                  i1yrs11i = 20
                  , i1yri21d = "${ff.myDT_getDate('today')}"
                WHERE
                  COALESCE(i1yrcz1i, 10) <> 0
                  AND i1yrb21f = ${global.t?.state.sgcd_cmnStgs.c20r_fst}
                  AND i1yri11d = "${_d_vals.i1yri11d}"
              `;
//ff.l('191: {}'.f(_qry))
              return _qry;
            },
          ],
        },

        i1yrs12i: { // 優先エントリー
          pfx: '抽選状況',
          type: 'Pck',
          n_col: 8,
          ld_iss: [
            { key: -1, pfx: ' ' },
            { key:  0, pfx: '抽選前' },
            { key: 20, pfx: '抽選済み' },
          ],
          lo_qrys: [
            _d_vals => {
              let _qry = `
                UPDATE
                  t_i1yr
                SET
                  i1yrs12i = 20
                  , i1yri21d = "${ff.myDT_getDate('today')}"
                WHERE
                  COALESCE(i1yrcz1i, 10) <> 0
                  AND i1yrb21f = ${global.t?.state.sgcd_cmnStgs.c20r_fst}
                  AND i1yri11d = "${_d_vals.i1yri11d}"
              `;
              ff.l('i1yd 219: {}'.f(_qry))
              return _qry;
            },
          ],
        },

      },
    },
  },

};

};
